import { Molecule, Wrapper, wrap } from 'AppReact'
import styled, { css } from 'styled-components';
import Text from 'atoms/text';
import Icon from './atoms/icon';

const labelIconWrapper = Wrapper(styled.div`
    display: flex;
    align-items: center;
`);

const marginWrapper = Wrapper(styled.div`
    margin-right: 0.25rem
`);

const template = styled.div`
  ${({ theme }) => css`
    display: flex;
    font-size: 12px;
    font-weight: 600;
    align-items: center;
    padding-left: 16px;
    padding-right: 16px;
    justify-content: space-between;
    height: 43px;
    min-width: 340px;

    border: 1px solid #E3E3E3;
    border-radius: 8px;

    box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.08);

    cursor: pointer;

    &:hover {
      border-color: ${theme?.colour?.primary ?? '#1DBD6B'};
    }

    ${({ isOpen }) => isOpen && css`
      border-color: ${theme?.colour?.primary ?? "#1DBD6B"};
      &:hover {
        border-color: ${theme?.colour?.primary ?? "#1DBD6B"};
      }  
    `}
  `}
`;

export default Molecule({
  template,
  type: 'button',
  atoms: [
    {
      wrapper: labelIconWrapper,
      name: "LabelIcon",
      atoms: [
        {
          component: wrap(Text, marginWrapper),
          name: 'Label',
          displayValue: () => 'Property: '
        },
        {
          component: Icon,
          name: 'Icon',
          displayValue: ({ selectedProperty }) => selectedProperty?.icon || ''
        },
        {
          component: Text,
          renderIf: ({ selectedProperty }) => selectedProperty,
          name: 'Name',
          displayValue: ({ selectedProperty }) => selectedProperty?.name || ''
        }
      ]
    }

  ]
})